import { Link } from "@mui/material";
import {
  FunctionField,
  NumberField,
  RaRecord,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { formatDateTimeWithSeconds } from "../../utils/DateTimeUtils";

const PromotionalBalanceMetaShow = (props: any) => {
  return (
    <Show {...props} actions={false}>
      <SimpleShowLayout>
        <NumberField label="Id" source="id" />
        <TextField label="Wallet Id" source="walletId" />
        <FunctionField sx={{
          display: 'inline-block',
          width: '65px',
        }} label="Customer Id" render={(record: RaRecord) => {
            return (
                <Link href={`/#/Customers/${record?.wallet?.userId}/show`}>
                    {record?.wallet?.userId}
                </Link>
                );
        }} />
        <TextField label="Amount" source="amount" />
        <TextField label="Status" source="status" />
        <FunctionField label="Added By" render={(record: RaRecord) => {
          if (!record?.createdBy) return '-';
          if (record?.createdByType === 'ADMIN') {
            return <Link href={`/#/AdminUsers/${record.createdBy}/show`}>{record.createdBy}</Link>;
          }
          if (record?.createdByType === 'CUSTOMER') {
            return <Link href={`/#/Customers/${record.createdBy}/show`}>{record.createdBy}</Link>;
          }
          return record.createdBy;
        }} />
        <TextField label="Added By Type" source="createdByType" />
        <TextField label="Payment Status" source="paymentStatus" />
        <FunctionField label="Payment Status Last Updated At" render={(record: any) => record?.paymentStatusLastUpdatedAt ? formatDateTimeWithSeconds(record.paymentStatusLastUpdatedAt) : '-'} />
        <FunctionField label="Created At" render={(record: any) => record?.createdAt ? formatDateTimeWithSeconds(record.createdAt) : '-'} />
        <FunctionField label="Expires At" render={(record: any) => record?.expiresAt ? formatDateTimeWithSeconds(record.expiresAt) : '-'} />
        <FunctionField label="Updated At" render={(record: any) => record?.updatedAt ? formatDateTimeWithSeconds(record.updatedAt) : '-'} />
        <TextField label="Campaign" source="cohortName" />
        <TextField label="Notes" source="notes" />
      </SimpleShowLayout>
    </Show>
  );
};

export default PromotionalBalanceMetaShow;
